import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFilters } from "@/context/FilterContext";
import { moisLabel } from "@/lib/api";

const FilterSelect = ({ id, value, onChange, placeholder, items }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-9 w-full sm:w-44 bg-white" data-testid={`filter-${id}`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all" data-testid={`filter-${id}-all`}>{placeholder}</SelectItem>
      {items.map((i) => (
        <SelectItem key={i.value} value={i.value} data-testid={`filter-${id}-${i.value}`}>
          {i.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const FilterBar = ({ showPlateforme = true, showMois = true }) => {
  const { filters, setFilter, options } = useFilters();
  return (
    <div className="flex flex-col sm:flex-row gap-2" data-testid="filter-bar">
      {showMois && <FilterSelect
        id="mois"
        value={filters.mois}
        onChange={(v) => setFilter("mois", v)}
        placeholder="Tous les mois"
        items={options.mois.map((m) => ({ value: m, label: moisLabel(m) }))}
      />}
      {showPlateforme && (
        <FilterSelect
          id="plateforme"
          value={filters.plateforme}
          onChange={(v) => setFilter("plateforme", v)}
          placeholder="Toutes plateformes"
          items={[{ value: "Airbnb", label: "Airbnb" }, { value: "Booking", label: "Booking" }]}
        />
      )}
      <FilterSelect
        id="logement"
        value={filters.logement}
        onChange={(v) => setFilter("logement", v)}
        placeholder="Tous les logements"
        items={options.logements.map((l) => ({ value: l, label: l }))}
      />
    </div>
  );
};

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between mb-8 rise">
    <div>
      <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-emerald-700">{eyebrow}</p>
      <h1 className="mt-1 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
    </div>
    {children}
  </div>
);
